<template>
  <html>
    <head>
      <meta charset="utf-8" />
      <meta
        name="viewport"
        content="width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no"
      />
      <meta name="mobile-web-app-capable" content="yes" />
      <meta name="apple-mobile-web-app-capable" content="yes" />
      <link rel="icon" type="image/png" href="favicon.png" />
      <title>Restó APP</title>
    </head>
    <body class="home-page">
      <Header :isRestoCompleto=true />
      <div class="col-lg-12 mx-auto p-3 py-md-5">
        <main>

          <div class="container">

            <div class="row ">
  <div class="col-6">
    <div class="row" style="text-align: initial;">
    <h3>Tienda en linea</h3></div>
     <h6  style="text-align: initial;">Usted seleccionó el siguiente paquete</h6>
  </div>


  <div class="col-6 align-items-center" v-if="reservasPendiente==null || reservasPendiente==0">

    <fieldset class="border" style="width: 100%;height: 100%;padding-top: 25px;">
      <h6  class="w-auto">Stock actual de reservas</h6>
      <h3>{{ stock }}</h3>
</fieldset>
  </div>


  <div class="col-3 align-items-center" v-if="reservasPendiente!=null && reservasPendiente!=0">

<fieldset class="border" style="width: 100%;height: 100%;padding-top: 25px;">
  <h6  class="w-auto">Stock actual de reservas</h6>
  <h3>{{ stock }}</h3>
</fieldset>
</div>


<div class="col-3 align-items-center" v-if="reservasPendiente!=null && reservasPendiente!=0">

<fieldset class="border" style="width: 100%;height: 100%;padding-top: 25px;">
  <h6  class="w-auto">Reservas pendientes</h6>
  <h3>{{ reservasPendiente }}</h3>
</fieldset>
</div>



  
</div>
          
<br>
<br>
          <div class="card">
  <div class="card-body">

    <div class="row ">
  <div class="col-12">
    <div class="row">
    <h3> {{ paquete.descripcion }}</h3></div>
     <h6>Contiene un paquete de reservas de {{ paquete.cantidadReservas }}  reservas limitadas</h6>
  </div>
  
</div>
<br>
<br>
    <div class="row align-items-center">

        <div class="col" style="text-align: left;">
       <span style="font-size: 20px;"> <b>El importe del paquete seleccionado es de $ {{ new Intl.NumberFormat('es-AR').format(paquete.precio)  }}</b></span>
     
    </div>
    <br>
    <br>
    <button type="button" class="btn btn-primary btn-sm" :disabled="disabelPagar"  @click="pagarMP()" >Pagar con mercado pago</button>
  </div>
  </div>
</div>
</div>     

          <PopUp
            :show="success"
            @close="
              success = false;
              if (firstTime) goToPageFirstTime('RegistrarMesa');
            "
          >
            <template #body>
              <p>{{ success_msg }}</p>
            </template>
          </PopUp>
          <PopUp :show="error" @close="error = false">
            <template #body>
              <p>{{ error_msg }}</p>
            </template>
          </PopUp>
          <PopUp :show="pagando" @close="cerrarMensajePagando()">
            <template #body>
              <p>Realizando pago, por favor siga los pasos en la pestaña abierta</p>
            </template>
          </PopUp>
          <PopUp :show="pagoExitoso" @close="pagoExitoso = false; cargarPaquete();">
            <template #body>
              <p>Paquete comprado exitosamente</p>
            </template>
          </PopUp>
        </main>
        <Footer />
      </div>
    </body>
  </html>
</template>

<script>
import axios from "axios";
import Header from "../components/Header.vue";
import Footer from "../components/Footer.vue";
import PopUp from "../components/PopUp.vue";
export default {
  name: "DetalleCompra",
  components: { Header, Footer, PopUp },
  data: function () {
    return {
      firstTime: false,
      restaurante: Object,
      error: false,
      error_msg: "",
      success: false,
      success_msg: "",
      paquete:{},
      disabelPagar:false,
      stock:null,
      pagando: false,
      timer: Object,
      referenciaId: String,
      pagoExitoso: false,
      reservasPendiente:null,
    };
  },
  methods: {
    cerrarMensajePagando() {
      this.pagando = false;
      clearInterval(this.timer);
    },
    iniciarCronCheckPago() {
      this.timer = setInterval(() => {
        axios
          .get("/mp/preferencia/"+this.referenciaId)
          .then((data) => {
            if (data.status == 200) {
              if(data.data.acreditado) {
                this.pagando = false;
                this.pagoExitoso=true;
                clearInterval(this.timer);
              }
            }
          });
      }, 1000);
    },
    cargarPaquete() {
      axios
        .get("/paquete-tienda/"+this.$route.params.id)
        .then((data) => {
          if (data.status == 200) {
           this.paquete=data.data;
          }
        })
        .catch(() => {
          this.error = true;
          this.error_msg =
            "No se ha podido actualizar la informacion. Vuelva a intentar mas tarde";
        });

        axios
        .get("/getStockReservas")
        .then((data) => {
          if (data.status == 200) {
            this.stock=data.data.cantidadSinVencer+data.data.cantidadVencer;
            this.reservasPendiente=data.data.cantidadPendiente
          }
        })
        .catch(() => {
          this.error = true;
          this.error_msg =
            "No se ha podido actualizar la informacion. Vuelva a intentar mas tarde";
        });
    },

    pagarMP(){
      this.pagando=true;
      this.disabelPagar=true;

      axios
        .post("/paquete-mp/"+this.$route.params.id)
        .then((data) => {
          this.disabelPagar=false;
          if (data.status == 200) {
            this.referenciaId = data.data.referenciaId;
            this.iniciarCronCheckPago();
           // Abrir nuevo tab
        var win = window.open(data.data.initPoint, '_blank');
        // Cambiar el foco al nuevo tab (punto opcional)
        win.focus();
          }
        })
        .catch(() => {
          this.disabelPagar=false;
          this.error = true;

          this.error_msg =
            "No se ha podido actualizar la informacion. Vuelva a intentar mas tarde";
        });
    }
  },
  beforeMount() {
    this.cargarPaquete();
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
};
</script>

<style scoped>
@import url("https://cdn.jsdelivr.net/npm/bootstrap@5.0.2/dist/css/bootstrap.min.css");
@import url("https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&display=swap");

:host {
  --main-color: #0047b3;
  --second-color: #0198f3;
  --grey-color: #f5f8fa;
  --border-radius-1: 9px;
  --border-radius-2: 6px;
}
body {
  font-family: "Inter", sans-serif;
  color: #083744;
  font-size: 14px;
  height: 100%;
}
.btn-primary {
  margin: 15px;
}
</style>
